import React, { useContext, useState } from "react"
import { Dimensions, View } from "react-native"
import { DimensionsContext } from "../../utils/mobileUtils"
import { IconButton } from "react-native-paper"
import { theme } from "../../theme/theme"
import TextM from "../text/TextM"
import FilledButtonM from "../button/FilledButtonM"
import { BadgeM } from "../badge/BadgeM"

function BannerCard({
    title = "",
    message = "",
    buttonLabel = "",
    onButtonClick = () => {},
    loading = false,
    onClose = () => {},
    cardStyle = {},
    titleStyle = {},
    messageStyle = {},
    buttonColor = theme.colors.primary,
    buttonStyle = {},
    badgeCount = null,
}) {
    const [showBanner, setShowBanner] = useState(true)
    const dimensions = useContext(DimensionsContext)

    if (!showBanner && !badgeCount) return null

    return (
        <View
            style={{
                borderTopWidth: 1,
                borderColor: theme.colors.lightMore,
                borderRadius: 10,
                padding: 20,
                backgroundColor: theme.colors.material.secondary["50"],
                width: Dimensions.get("window").width,
                justifyContent: "center",
                ...cardStyle,
            }}
        >
            <View
                style={{
                    width: dimensions.width,
                    alignSelf: "center",
                    paddingHorizontal: 20,
                }}
            >
                <View>
                    <TextM
                        fontWeight={"Bold"}
                        color={theme.colors.primary}
                        wrap
                        fontSize={18}
                        style={{
                            maxWidth: "90%",
                            ...titleStyle,
                        }}
                    >
                        {title}
                    </TextM>
                    <TextM
                        wrap
                        style={{
                            marginTop: 10,
                            ...messageStyle,
                        }}
                        color={theme.colors.primary}
                    >
                        {message}
                    </TextM>
                </View>
                <View
                    style={{
                        marginTop: 20,
                        alignSelf: "flex-start",
                    }}
                >
                    <FilledButtonM
                        style={{
                            width:
                                dimensions.width > 800
                                    ? dimensions?.width / 3
                                    : null,
                            ...buttonStyle,
                        }}
                        color={buttonColor}
                        label={buttonLabel}
                        loading={loading}
                        disabled={loading}
                        onPress={onButtonClick}
                    />
                </View>
            </View>
            {!badgeCount ? (
                <IconButton
                    icon={"times"}
                    iconColor={theme.colors.primary}
                    size={26}
                    style={{
                        position: "absolute",
                        right: 4,
                        top: 0,
                        backgroundColor: theme.colors.transparent,
                    }}
                    onPress={() => {
                        setShowBanner(false)
                        onClose()
                    }}
                />
            ) : (
                <BadgeM
                    style={{
                        backgroundColor: theme.colors.error,
                        position: "absolute",
                        right: 12,
                        top: 6,
                        color: theme.colors.white,
                    }}
                    count={badgeCount}
                    size={20}
                />
            )}
        </View>
    )
}

export default BannerCard
